import { makeStyles } from '@material-ui/core';

import { neutral, orange } from 'shared/styles/colors';

export default makeStyles({
  root: {
    padding: '0.75rem',
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    lineHeight: '1rem',
    fontWeight: 400,
    borderRadius: '0.5rem',
    border: `1px solid ${neutral['20']}`,
    color: neutral['100'],
    backgroundColor: neutral.white,
  },

  //++++ HEADER ++++
  header: {
    marginBottom: '0.25rem',
  },
  headerTitle: {
    margin: 0,
    fontWeight: 700,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    letterSpacing: '0.12em',
    color: neutral['80'],
    textTransform: 'uppercase',
  },
  //---- header ----

  //++++ MAIN ++++
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },
  userInfo: {
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  userInfoName: {
    margin: 0,
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
  userTags: {
    display: 'flex',
    gap: '0.5rem',
  },
  callUserDisclaimer: {
    margin: 0,
    padding: '0.75rem',
  },
  callUserDisclaimerIcon: {
    fontSize: '1.5rem !important',
    fontWeight: 'bold',
  },
  callUserDisclaimerText: {
    fontFamily: 'PP Object Sans',
    fontWeight: 400,
  },
  contactInfo: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'PP Object Sans',
    color: neutral['80'],
  },
  contactInfoData: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0, // Allows the content to adjust dynamically
  },
  contactInfoPhone: {
    margin: 0,
    fontFamily: 'PP Object Sans',
  },
  contactInfoDirection: {
    marginTop: '0.25rem',
    '& > p': {
      margin: 0,
      fontFamily: 'PP Object Sans',
    },
  },
  contactInfoMapBtn: {
    padding: 0,
    flexShrink: 0,
    fontFamily: 'PP Object Sans',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    lineHeight: '1rem',
    textDecoration: 'underline',
    color: neutral['100'],
  },
  billAlert: {
    marginBottom: '0.5rem',
    padding: '0.25rem 0.75rem',
    borderRadius: '0.5rem',
    color: neutral['80'],
    backgroundColor: orange['10'],
    '& .MuiAlert-icon': {
      padding: '0.5rem 0',
      color: orange['60'],
    },
    '& .MuiAlert-message': {
      fontFamily: 'PP Object Sans',
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '1rem',
    },
  },
  emitBillData: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.125rem',
    color: neutral['80'],
    '& p': {
      margin: 0,
      fontFamily: 'PP Object Sans',
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '1rem',
    },
  },
  //---- main ----

  //++++ FOOTER ++++
  footer: ({ showFooter = false }) => ({
    marginTop: '0.75rem',
    display: showFooter ? 'flex' : 'none',
    gap: '0.25rem',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'PP Object Sans',
  }),
  //---- footer ----
});
